import styled, { css } from "styled-components";
import { useDesignTokens } from "@boi/react-design-tokens";

import { ContainerBase } from "../Modal/Modal.styled";

export const Container = styled(ContainerBase)`
  display: grid;
  grid-template-rows: auto 1fr auto;
`;

type HeaderProps = {
  $borderVisible: boolean;
};

export const Header = styled.header<HeaderProps>`
  ${({ $borderVisible }) => {
    const { tokens } = useDesignTokens();
    const { standardModal, modal } = tokens;

    return [
      css`
        display: grid;
        align-items: center;
        grid-template-columns: 1fr auto;
        gap: ${standardModal.header.gap};
        overflow: hidden;
        border-bottom-width: ${standardModal.header.stroke.bottom.width};
        border-bottom-style: ${standardModal.header.stroke.bottom.style};
        border-bottom-color: transparent;
        padding-top: ${standardModal.header.padding.mobile.top};
        padding-left: ${standardModal.header.padding.mobile.left};
        padding-right: ${standardModal.header.padding.mobile.right};
        padding-bottom: ${standardModal.header.padding.mobile.bottom};
        transition: border-bottom-color 0.15s;

        @media (min-width: ${modal.breakpoints.tablet}) {
          padding-top: ${standardModal.header.padding.tablet.top};
          padding-left: ${standardModal.header.padding.tablet.left};
          padding-right: ${standardModal.header.padding.tablet.right};
          padding-bottom: ${standardModal.header.padding.tablet.bottom};
        }
      `,
      $borderVisible &&
        css`
          border-bottom-color: ${standardModal.header.stroke.bottom.color};
        `,
    ];
  }}
`;

type MiniHeadingWrapperProps = {
  $headingVisible: boolean;
};

export const MiniHeadingWrapper = styled.div<MiniHeadingWrapperProps>`
  ${({ $headingVisible }) => {
    const {
      tokens: {
        modal,
        standardModal: {
          header: { padding },
        },
      },
    } = useDesignTokens();

    const translateY = `calc(${padding.mobile.top} + ${padding.mobile.bottom} + 100%)`;
    const tabletTranslateY = `calc(${padding.mobile.top} + ${padding.mobile.bottom} + 100%)`;

    return [
      css`
        overflow: hidden;
        transition: transform 0.35s;
        transform: translateY(${translateY});
        @media (min-width: ${modal.breakpoints.tablet}) {
          transform: translateY(${tabletTranslateY});
        }
      `,
      !$headingVisible &&
        css`
          && {
            transform: translateY(0);
          }
        `,
    ];
  }}
`;
export const CloseButtonWrapper = styled.div`
  margin: -6px;
  margin-top: -10px;
  margin-bottom: -11px;
`;

export const Content = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { standardModal, modal } = tokens;

    return css`
      display: grid;
      gap: ${standardModal.content.gap};
      padding-top: ${standardModal.content.padding.mobile.top};
      padding-left: ${standardModal.content.padding.mobile.left};
      padding-right: ${standardModal.content.padding.mobile.right};
      padding-bottom: ${standardModal.content.padding.mobile.bottom};

      @media (min-width: ${modal.breakpoints.tablet}) {
        padding-top: ${standardModal.content.padding.tablet.top};
        padding-left: ${standardModal.content.padding.tablet.left};
        padding-right: ${standardModal.content.padding.tablet.right};
        padding-bottom: ${standardModal.content.padding.tablet.bottom};
      }
    `;
  }}
`;

export const Footer = styled.footer`
  ${() => {
    const { tokens } = useDesignTokens();
    const { standardModal, modal } = tokens;

    return css`
      height: ${standardModal.footer.height.mobile};
      @media (min-width: ${modal.breakpoints.tablet}) {
        height: ${standardModal.footer.height.tablet};
      }
    `;
  }}
`;
